import ErrorMessageManagementComponent from 'components/desktop/StandingData/ErrorMessage/Management/ErrorMessageManagementComponent';

const ErrorMessageArchiveContainer = () => {
	const renderContent = () => {
		return (
			<main className="container">
				<ErrorMessageManagementComponent archive={true} />
			</main>
		);
	};

	return <>{renderContent()}</>;
};

export default ErrorMessageArchiveContainer;
